import { Button, Divider, Form, Input } from 'antd';
import { useTranslation } from 'react-i18next';
import { ArrowLeftOutlined, ArrowRightOutlined } from '@ant-design/icons';
import Sticky from 'react-sticky-el';
import BtnSave from './BtnSave';
import Editor from '../../../../components/Shared/forms/EditorPrivacy';
import TextBox from '../../Shared/TextBox';
import { EXAMLE, INIT } from './init';
import { checkValidForm } from './Step1';
import { useEffect } from 'react';
import { POLICY_NAME } from '../../POLICY';

const Step4 = (props) => {
    const { previewData, setStep4 } = props;
    const { t } = useTranslation(['translation', 'cookies-policy']);

    useEffect(() => {
        if (previewData) {
            let check = true;
            const allowKey = [
                'cookieSettingTitleTh',
                'cookieSettingTitleEn',
                'cookieSettingContentTh',
                'cookieThirdPartyTitleTh',
                'cookieThirdPartyTitleEn',
            ];
            for (const [key, value] of Object.entries(
                previewData?.cookiePreferences
            )) {
                if (allowKey.includes(key) && !value) {
                    check = false;
                }
            }
            setStep4(check);
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [previewData]);

    const onNextStep = () => {
        props.nextStep();
        props?.form
            .validateFields()
            .then(() => {
                props.setStep4(true);
            })
            .catch(() => props.setStep4(false));
    };

    const onPreviousStep = () => {
        props.previousStep();
    };

    useEffect(() => {
        if (props?.previewData?.cookiePreferences) {
            onValuesChange(null, props.previewData?.cookiePreferences);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props?.previewData]);

    const onValuesChange = (change, allValues) => {
        const fields = [
            'cookieSettingTitleTh',
            'cookieSettingTitleEn',
            'cookieSettingContentTh',
            'cookieThirdPartyTitleTh',
            'cookieThirdPartyTitleEn',
        ];
        const check = checkValidForm(fields, allValues);
        props.setStep4(check);
    };

    return (
        <div className="px-4 block_">
            <div className="text-purple-PHX font-semibold text-2xl">
                {t('cookies-policy.Cookies Preferences', {
                    ns: POLICY_NAME.COOKIES_POLICY,
                })}
            </div>
            <div className="text-gray-500 text-tiny">{t('policy.desEtc')}</div>
            <Divider />
            <Form
                scrollToFirstError={{
                    behavior: 'smooth',
                    block: 'center',
                }}
                onValuesChange={onValuesChange}
                name="cookiePreferences"
                layout="vertical"
                form={props?.form}
                initialValues={INIT.cookiePreferences}
            >
                <div>
                    <div className="text-purple-PHX font-semibold text-xl">
                        {t('Setting and disabling of Cookies', {
                            ns: POLICY_NAME.COOKIES_POLICY,
                        })}
                    </div>
                    <Form.Item
                        label={
                            <span className="text-sm font-semibold">
                                {t(
                                    'Title of the topic displayed in the document',
                                    {
                                        ns: POLICY_NAME.COOKIES_POLICY,
                                        lang: 'TH',
                                    }
                                )}
                            </span>
                        }
                        rules={[
                            {
                                required: true,
                                message: t('errorText.requiredField'),
                            },
                        ]}
                        name="cookieSettingTitleTh"
                    >
                        <Input size="large" maxLength={200} showCount />
                    </Form.Item>
                    <div className="text-sm font-semibold">
                        {t('Example Data')}
                    </div>
                    <TextBox
                        code={EXAMLE.cookiePreferences.cookieSettingContentTh}
                    />
                    <Form.Item
                        className="mt-4"
                        name="cookieSettingContentTh"
                        label={
                            <span className="text-sm font-semibold">
                                {t('Content', { lang: 'TH' })}
                            </span>
                        }
                        rules={[
                            {
                                required: true,
                                message: t('errorText.requiredField'),
                            },
                        ]}
                    >
                        <Editor
                            size="large"
                            rows={4}
                            placeholder={t('Content', { lang: 'TH' })}
                        />
                    </Form.Item>

                    <Form.Item
                        label={
                            <span className="text-sm font-semibold">
                                {t(
                                    'Title of the topic displayed in the document',
                                    {
                                        ns: POLICY_NAME.COOKIES_POLICY,
                                        lang: 'EN',
                                    }
                                )}
                            </span>
                        }
                        rules={[
                            {
                                required: true,
                                message: t('errorText.requiredField'),
                            },
                        ]}
                        name="cookieSettingTitleEn"
                    >
                        <Input size="large" maxLength={200} showCount />
                    </Form.Item>
                    <div className="text-sm font-semibold">
                        {t('Example Data')}
                    </div>
                    <TextBox
                        code={EXAMLE.cookiePreferences.cookieSettingContentEn}
                    />
                    <Form.Item
                        className="mt-4"
                        name="cookieSettingContentEn"
                        label={
                            <span className="text-sm font-semibold">
                                {t('Content', { lang: 'EN' })}
                            </span>
                        }
                    >
                        <Editor
                            size="large"
                            rows={4}
                            placeholder={t('Content', { lang: 'EN' })}
                        />
                    </Form.Item>
                </div>
                <Divider />
                <div>
                    <div className="text-purple-PHX font-semibold text-xl">
                        {t('Third-Party Cookies', {
                            ns: POLICY_NAME.COOKIES_POLICY,
                        })}
                    </div>
                    <Form.Item
                        label={
                            <span className="text-sm font-semibold">
                                {t(
                                    'Title of the topic displayed in the document',
                                    {
                                        ns: POLICY_NAME.COOKIES_POLICY,
                                        lang: 'TH',
                                    }
                                )}
                            </span>
                        }
                        rules={[
                            {
                                required: true,
                                message: t('errorText.requiredField'),
                            },
                        ]}
                        name="cookieThirdPartyTitleTh"
                    >
                        <Input size="large" maxLength={200} showCount />
                    </Form.Item>
                    <div className="text-sm font-semibold">
                        {t('Example Data')}
                    </div>
                    <TextBox
                        code={
                            EXAMLE.cookiePreferences.cookieThirdPartyContentTh
                        }
                    />
                    <Form.Item
                        className="mt-4"
                        name="cookieThirdPartyContentTh"
                        label={
                            <span className="text-sm font-semibold">
                                {t('Content', { lang: 'TH' })}
                            </span>
                        }
                    >
                        <Editor
                            size="large"
                            rows={4}
                            placeholder={t('Content', { lang: 'TH' })}
                        />
                    </Form.Item>

                    <Form.Item
                        label={
                            <span className="text-sm font-semibold">
                                {t(
                                    'Title of the topic displayed in the document',
                                    {
                                        ns: POLICY_NAME.COOKIES_POLICY,
                                        lang: 'EN',
                                    }
                                )}
                            </span>
                        }
                        rules={[
                            {
                                required: true,
                                message: t('errorText.requiredField'),
                            },
                        ]}
                        name="cookieThirdPartyTitleEn"
                    >
                        <Input size="large" maxLength={200} showCount />
                    </Form.Item>
                    <div className="text-sm font-semibold">
                        {t('Example Data')}
                    </div>
                    <TextBox
                        code={
                            EXAMLE.cookiePreferences.cookieThirdPartyContentEn
                        }
                    />
                    <Form.Item
                        className="mt-4"
                        name="cookieThirdPartyContentEn"
                        label={
                            <span className="text-sm font-semibold">
                                {t('Content', { lang: 'EN' })}
                            </span>
                        }
                    >
                        <Editor
                            size="large"
                            rows={4}
                            placeholder={t('Content', { lang: 'EN' })}
                        />
                    </Form.Item>
                    <Form.Item hidden name="cookieSettingIsDisplay"></Form.Item>
                    <Form.Item
                        hidden
                        name="cookieThirdPartyIsDisplay"
                    ></Form.Item>
                </div>
                <Sticky
                    mode="bottom"
                    boundaryElement=".block_"
                    stickyClassName="bg-white p-4 shadow h-16 rounded-lg z-50"
                >
                    <div className="flex items-center">
                        <Button
                            type="default"
                            size="large"
                            onClick={onPreviousStep}
                        >
                            <ArrowLeftOutlined /> {t('policy.PreviousStep')}
                        </Button>
                        <Button
                            type="primary"
                            size="large"
                            className="ml-4"
                            onClick={onNextStep}
                        >
                            {t('policy.NextStep')} <ArrowRightOutlined />
                        </Button>
                        <BtnSave saveDraft={props.saveDraft} />
                    </div>
                </Sticky>
            </Form>
        </div>
    );
};

export default Step4;
